module.exports = __webpack_public_path__ + "img/x_white.c8cfd8d0.svg";